import { FilterVue } from './filterVue'

export const Filter = (() => {
	const filterVue = FilterVue()
	const init = (isAjax: boolean) => {
		filterVue.init(isAjax)
	}

	return {
		init,
	}
})()
